var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFinishedStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint0_linear_1450_20958)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "url(#paint1_linear_1450_20958)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1532 13.408C18.4202 11.136 19.0532 10 20.0002 10C20.9472 10 21.5802 11.136 22.8472 13.408L23.1752 13.996C23.5352 14.642 23.7152 14.965 23.9952 15.178C24.2752 15.391 24.6252 15.47 25.3252 15.628L25.9612 15.772C28.4212 16.329 29.6502 16.607 29.9432 17.548C30.2352 18.488 29.3972 19.469 27.7202 21.43L27.2862 21.937C26.8102 22.494 26.5712 22.773 26.4642 23.117C26.3572 23.462 26.3932 23.834 26.4652 24.577L26.5312 25.254C26.7842 27.871 26.9112 29.179 26.1452 29.76C25.3792 30.342 24.2272 29.811 21.9252 28.751L21.3282 28.477C20.6742 28.175 20.3472 28.025 20.0002 28.025C19.6532 28.025 19.3262 28.175 18.6722 28.477L18.0762 28.751C15.7732 29.811 14.6212 30.341 13.8562 29.761C13.0892 29.179 13.2162 27.871 13.4692 25.254L13.5352 24.578C13.6072 23.834 13.6432 23.462 13.5352 23.118C13.4292 22.773 13.1902 22.494 12.7142 21.938L12.2802 21.43C10.6032 19.47 9.76523 18.489 10.0572 17.548C10.3502 16.607 11.5802 16.328 14.0402 15.772L14.6762 15.628C15.3752 15.47 15.7242 15.391 16.0052 15.178C16.2852 14.965 16.4652 14.642 16.8252 13.996L17.1532 13.408Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1450_20958",
    x1: -2.93769,
    y1: -3.60062e-7,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1450_20958",
    x1: 20.0068,
    y1: -4.44749e-7,
    x2: 33.6033,
    y2: 34.6675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A011"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFinishedStep);
export default __webpack_public_path__ + "static/media/not_finished_step.64b14ea8c40fd8742366ddc1a3227b20.svg";
export { ForwardRef as ReactComponent };